<script setup lang="ts">
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { AkParagraph, AkTooltipInformation, AkIcon, AkLink } from '@ankorstore/design-system';
import { useStore } from 'vuex';

const i18n = useI18n();
const store = useStore();

const isBrandWithAdsEnabled = computed(() => {
  return store.getters.isUserAuthenticated && !store.getters.userIsRetailer;
});
const sponsoredItemTooltipContent = computed(() => {
  return isBrandWithAdsEnabled.value
    ? i18n.t('sponsorCarousel.label.tooltipTextForBrand')
    : i18n.t('sponsorCarousel.label.tooltipText');
});

const navigateToBrandDashboardAds = () => {
  window.location.assign('/account/brand-dashboard-ads');
};

/* Test utility to allow the tooltip to be shown in tests */
const _isTooltipShown = ref(false);
const _showTooltip = () => (_isTooltipShown.value = true);
defineExpose({ _showTooltip });
/* End test utility */
</script>

<template>
  <div class="card-product-sponsored-label">
    <AkParagraph
      uppercase
      class="card-product-sponsored-label__text"
      data-testid="sponsored-label"
    >
      {{ $t('catalog.sponsoredItems.label') }}
    </AkParagraph>
    <AkTooltipInformation
      trigger="hover"
      placement="right"
      type="success"
      :show="_isTooltipShown"
    >
      <AkIcon
        symbol="info-circle"
        class="ds-text-neutral-900"
        data-testid="sponsored-info-icon"
      />
      <template #container>
        <AkLink
          v-if="isBrandWithAdsEnabled"
          class="hover:ds-text-white"
          size="sm"
          color="white"
          data-testid="sponsored-tooltip-link"
          @click="navigateToBrandDashboardAds"
        >
          {{ sponsoredItemTooltipContent }}
        </AkLink>
        <AkParagraph
          v-else
          data-testid="sponsored-tooltip-text"
        >
          {{ sponsoredItemTooltipContent }}
        </AkParagraph>
      </template>
    </AkTooltipInformation>
  </div>
</template>

<style scoped lang="scss">
.card-product-sponsored-label {
  display: flex;
  align-items: center;
  margin-top: theme('spacing.2');
}

.card-product-sponsored-label__text {
  margin-right: theme('spacing.1');
  color: theme('colors.neutral.900');
}
</style>
